export const matjungelenGreen = '#365e1b';
export const matjungelenDarkGreen = '#253a13';
export const matjungelenAmber = '#f6f5e4';

